import { useEffect } from 'react';
const removeKeyboardFocusTraps = () => {
    var _a;
    document.querySelectorAll('[tabindex]').forEach((el) => {
        el.removeAttribute('tabindex');
    });
    document.querySelectorAll('[role=article]').forEach((el) => {
        el.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('[role=button]').forEach((el) => {
        el.setAttribute('tabindex', '0');
    });
    document
        .querySelectorAll('.webchat__carousel-filmstrip__attachments, .webchat__carousel-filmstrip__attachments > li')
        .forEach((el) => {
        el.setAttribute('tabindex', '0');
    });
    (_a = document.querySelector('.webchat__keyboard-help')) === null || _a === void 0 ? void 0 : _a.remove();
};
export const useRemoveWebchatKeyboardFocusTraps = () => {
    useEffect(removeKeyboardFocusTraps, []);
};
export const removeKeyboardInstructionStrings = {
    ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT: ' ',
    ACTIVITY_INTERACTIVE_LABEL_ALT: ' ',
    ACTIVITY_INTERACTIVE_WITH_LINKS_LABEL_ALT: ' ',
    ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT: ' ',
    TRANSCRIPT_ARIA_LABEL_ALT: 'Chat history',
    TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT: ' ',
    TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT: ' '
};
//# sourceMappingURL=useRemoveWebchatKeyboardFocusTraps.js.map